import { Microfrontend } from '@cian/mf-react';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';

import { useSaveSearchModal } from './hooks';
import { useApplicationContext } from '../ApplicationContext';

export const DesktopFiltersMicrofrontend: React.FC = () => {
  const { config } = useApplicationContext();

  const manifest = config.get<IMicrofrontendManifest | null>('desktopFiltersMicrofrontendManifest');

  useSaveSearchModal();

  if (!manifest) {
    return null;
  }

  return (
    <Microfrontend
      name={manifest.microfrontendName}
      image={manifest.imageVersion}
      runtime={manifest.runtimeName}
      instance={manifest.instanceId}
    />
  );
};
